import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseContactRoute } from "@/lib/data/requests/contacts/contact";
import type { APIResponse } from "@/lib/types/APIResponse";

export interface ContactPortalAccess {
  contactId: string;
  activeConnection: boolean;
  portalAccess?: {
    accountEmail?: string | null;
  } | null;
  invitationId?: string | null;
  status?: string | null;
  invitedEmail?: string | null;
  expiresAt?: string | null;
  deliveryState?: string | null;
}

export const retrieveContactPortalAccess = (contactId: string) =>
  authenticatedFastApiAxiosInstance
    .get<
      APIResponse<ContactPortalAccess>
    >(`${baseContactRoute}/${contactId}/portal-access`)
    .then((response) => response.data);

export const revokeContactPortalAccess = (contactId: string) =>
  authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<ContactPortalAccess>
    >(`${baseContactRoute}/${contactId}/portal-access`)
    .then((response) => response.data);

export const cancelContactPortalInvitation = ({
  contactId,
  invitationId,
}: {
  contactId: string;
  invitationId: string;
}) =>
  authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<ContactPortalAccess>
    >(`${baseContactRoute}/${contactId}/portal-invitations/${invitationId}`)
    .then((response) => response.data);

export const resendContactPortalInvitation = ({
  contactId,
  invitationId,
  idempotencyKey,
}: {
  contactId: string;
  invitationId: string;
  idempotencyKey: string;
}) =>
  authenticatedFastApiAxiosInstance
    .post<
      APIResponse<ContactPortalAccess>
    >(`${baseContactRoute}/${contactId}/portal-invitations/${invitationId}/resend`, undefined, { headers: { "Idempotency-Key": idempotencyKey } })
    .then((response) => response.data);

export const createContactPortalInvitation = ({
  contactId,
  email,
  idempotencyKey,
}: {
  contactId: string;
  email: string;
  idempotencyKey: string;
}) =>
  authenticatedFastApiAxiosInstance
    .post<
      APIResponse<ContactPortalAccess>
    >(`${baseContactRoute}/${contactId}/portal-invitations`, { email }, { headers: { "Idempotency-Key": idempotencyKey } })
    .then((response) => response.data);
